import { render } from "./RetainDialog.vue?vue&type=template&id=5a242a4e&scoped=true&ts=true"
import script from "./RetainDialog.vue?vue&type=script&lang=ts"
export * from "./RetainDialog.vue?vue&type=script&lang=ts"

import "./RetainDialog.vue?vue&type=style&index=0&id=5a242a4e&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a242a4e"]])